import Viewer from './TextFieldsViewer';
import TextFieldsEditor from './TextFieldsEditor';

export const TextFieldsViewer = Viewer;
export default TextFieldsEditor;
